import React, { FC } from 'react';
import { useQuery } from 'react-apollo';
import { useSearchParam } from 'react-use';

import ViboLogo from '../../common/ViboLogo';
import HeadingWithImage from '../../common/HeadingWithImage';

import { GET_EVENT_PREVIEW_VIA_LINK } from 'graphql/queries/events';

import useStyles from './style';

const DeepLinkLoginPreview: FC = () => {
  const classes = useStyles();

  const deepLink = useSearchParam('url') || '';

  const { data } = useQuery<GetEvenPreviewViaLink>(GET_EVENT_PREVIEW_VIA_LINK, {
    variables: {
      deepLink,
    },
    skip: !deepLink,
  });
  const event = data?.getEvenPreviewViaLink as EventDeepLinkPreview;

  const previewData = {
    title: event?.title,
    photo: { url: event?.image.squareUrl, token: event?._id },
  };

  return !!event ? (
    <HeadingWithImage className={classes.previewInfo} {...previewData} />
  ) : (
    <ViboLogo />
  );
};

export default DeepLinkLoginPreview;
